/**
 * Client configuration, read once from the build-time environment.
 *
 * VITE_API_URL comes from the repo-root `.env` (see `envDir` in vite.config).
 * The fallback matches the local server port so a fresh checkout works with
 * no client-side configuration at all.
 */
export const API_URL: string = import.meta.env.VITE_API_URL ?? 'http://localhost:4000';

/*
 * **The Stripe publishable key is gone from the client** - P-5, approved 25
 * September 2026.
 *
 * It was exported here with the comment "Populated from Phase 2 onwards", and
 * Phase 2 never needed it: **checkout is hosted by Stripe**, so no card data
 * touches this bundle and no publishable key is required to send a browser to
 * a session URL. Nothing read the export.
 *
 * `STRIPE_PUBLISHABLE_KEY` on the **server** stays and is used: `stripeMode.ts`
 * reads it for the D-12 same-mode consistency guard. The WAIT-A note calling
 * the key unused was reading this one.
 */
